import axios from "axios"
import {backUrl} from "../../urls";
import {handleEncryption, needEncryption} from "../../helpers";
import {
    browserName,
    osName,
    osVersion,
    mobileModel,
    engineVersion,
    engineName,
    browserVersion
} from "react-device-detect"

const https = require('https');

const Api = axios.create({
    baseURL: backUrl,
    httpsAgent: new https.Agent({
        rejectUnauthorized: false
    }),
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'

    },
},);
Api.interceptors.request.use(async function (config) {

    // Check if data exists and if it's an object (assuming parameters are an object)
    if (config.data && typeof config.data === 'object' && needEncryption(config.url)) {

        config.data = await handleEncryption({
            ...config.data,
            browserName,
            osName,
            osVersion,
            mobileModel,
            engineVersion,
            engineName,
            browserVersion
        });
    } else {
        config.data = {
            ...config.data,
            browserName,
            osName,
            osVersion,
            mobileModel,
            engineVersion,
            engineName,
            browserVersion
        }
    }
    if (config.params && Object.keys(config.params).length > 0 && needEncryption(config.url)) {
        const params = await handleEncryption({
            ...config.params,
            browserName,
            osName,
            osVersion,
            mobileModel,
            engineVersion,
            engineName,
            browserVersion
        });
        const encryptedParams = {};
        for (const key in params) {
            encryptedParams[key] = params[key]
        }

        config.params = encryptedParams;
    } else {
        config.params = {
            ...config.params,
            browserName,
            osName,
            osVersion,
            mobileModel,
            engineVersion,
            engineName,
            browserVersion
        }
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
Api.interceptors.response.use(function (response) {
    const {data: res} = response;
    const {code: status, data, status: noError, faMessage, message} = res;

    if (status === 401 &&  window && !window.location.href.includes('/login')) {
      /*  window.location.href='/tosan/accessDenied';*/

        return {
            status: status,
            data: data,
            isOk:noError,
            message: faMessage ? faMessage : message,
        }

    } else {

        return {
            status: status,
            data: data,
            isOk:noError,
            message: faMessage ? faMessage : message,
        }
    }

}, function (error) {
    if (axios.isCancel(error)) {
        return {
            isOk:false,
            canceled:true,
            data: null,
            status: error?.response?.status || "",
            message: error?.response?.message || "",
        }
    } else if (error.code === 'ECONNABORTED') {
        return {
            isOk: false,
            data: null,

            status: error?.response?.status || "",
            message: error?.response?.message || "دسترسی به اینترنت خود را بررسی کنید",
        }
    } else {
        return {
            isOk: false,
            data: null,
            status: error?.response?.status || "",
            message: error?.response?.message || "",
        }
    }


});

export default Api;